import React, { useEffect, useState } from "react";
import {Formik, Field, Form} from "formik";
import { Stack, Button } from "@mui/material";
import { TextField, Select} from "formik-mui";
import { fetchAPI } from "@/utility/NetworkUtils";
import MenuItem from '@mui/material/MenuItem';
const RenterForm = ({
  renter,
  user,
  onCancel,
  onSubmit
}) => {
  const [ error, setError ] = useState(null);
  const renderForm = (formikProps) => {
    return (
      <Form>
        <Stack spacing={2}>
          <div>
            <label>
              Client Name
            </label>
            <Field
              name="renter[name]"
              component={TextField}
              fullWidth
            />
          </div>
          <div>
            <label>
              Color Scheme
            </label>
            <br/>
            <Field
              name="renter[color_scheme]"
              component={Select}
              fullWidth
            >
              <MenuItem value="blue">Blue (Default)</MenuItem>
              <MenuItem value="red">Red</MenuItem>
            </Field>
          </div>
          {error && <div>{error}</div>}
          <div>
            {renderButtons(formikProps)}
          </div>
        </Stack>
      </Form>
    )
  }
          

  const renderButtons = (formikProps) => {
    return (
      <Stack
        direction="row"
        justifyContent="flex-end"
        spacing={2}
      >
        <Button
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          disabled={formikProps.isSubmitting}
        >
          Save
        </Button>
      </Stack>
    )
  }
        
  const isEditing = renter && renter.id
  const attemptSubmit = (values, { setSubmitting }) => {
    fetchAPI(isEditing ? `/webapi/renters/${renter.id}` : `/webapi/renters`, (json)=> {
      if (!json.error) {
        onSubmit(
          json.renter
        )
      } else {
        setError(json.error)
      }
      setSubmitting(false)
    }, {
      method: isEditing ? "PATCH" : "POST",
      body: values
    })
  }

  return (
    <Formik
      initialValues={{
        renter: {
          name: renter ? renter.name : null,
          color_scheme: renter ? renter.color_scheme : "blue"
        }
      }}
      onSubmit={(values, actions) => {
        attemptSubmit(values, actions)
      }}
      enableReinitialize
    >
      {(formikProps) => renderForm(formikProps)}
    </Formik>
  )
}


export default RenterForm